<template>
  <div>
    <div
      v-if="!centerCarousel"
      class="l-flex l-flex--items-center l-flex--justify-start"
    >
      <h2
        v-if="title"
        :class="titleClass"
      >
        {{ title.Text }}
      </h2>
      <div class="l-grid l-grid--2-col">
        <div />
        <p class="t-heading-10">
          From Fans Like You
        </p>
      </div>
    </div>
    <div v-else>
      <h2
        v-if="title"
        :class="titleClass"
      >
        {{ title.Text }}
      </h2>
    </div>
    <div
      v-if="reviews && reviews.length > 0"
      :class="productCarouselClass"
      role="region"
    >
      <flickity
        v-if="flickityActive && false"
        ref="flickity"
        class="flickity"
        :options="flickityOptions"
      >
        <div
          v-for="(review, index) in mappedReviews"
          :key="`f-${review.id}--${index}`"
          class="carousel-cell"
        >
          <review-card v-bind="review" />
        </div>
      </flickity>
      <div
        v-else
        class="l-grid l-grid--3-col"
      >
        <template v-for="(review, index) in mappedReviews">
          <div
            :key="`e-${review.id}--${index}`"
            class="c-review-carousel__item"
          >
            <review-card
              v-bind="review"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewCard from "../card/ReviewCard.vue";
import flickityActive  from './flickityActive'
import get from 'lodash/get'

export default {
  components: { ReviewCard },
  mixins: [
    flickityActive
  ],
  props: {
    title: {
      type: Object,
      default: () => ({}),
    },
    reviews: {
      type: Array,
      default: () => []
    },
    centerCarousel: {
      type: Boolean,
      default: false
    },
    forceMobile: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        freeScroll: true,
        cellAlign: '',
        imagesLoaded: true,
        // any options from Flickity can be used
        // https://flickity.metafizzy.co/options.html
      }
    }
  },
  computed: {
    productCarouselClass() {
      let results = ['c-review-carousel'];
      if (this.forceMobile) {
        results.push('c-review-carousel--mobile');
      }
      if (this.centerCarousel) {
        results.push('c-review-carousel--center-carousel');
      }
      return results;
    },
    mappedReviews() {
      const reviews = this.reviews
      let results = reviews.map((review) => {
        const result = {
          id: get(review, 'reviewId'),
          author: get(review, 'reviewer.displayName'),
          date: get(review, 'dateUpdated'),
          title: get(review, 'title'),
          description: get(review, 'body'),
          rating: get(review, 'rating'),
          productId: get(review, 'productId'),
          textAlignment: this.centerCarousel ? 'center' : 'left'
        }

        return result
      })

      return results
    },
    titleClass() {
      let results = ["c-review-carousel__title"];
      const title = this.title;
      const headingStyle = "t-heading-4";
      const textColor = this.textColor;
      if (title.HeadingStyle) {
        results.push(title.HeadingStyle, `${title.HeadingStyle}--${textColor}`);
      } else {
        results.push(`${headingStyle}--` + textColor);
        results.push("t-heading-4");
      }

      if (title.MarginBottom) {
        results.push(`u-margin-bottom-${title.MarginBottom}`);
      }
      if (title.Alignment) {
        results.push(`u-text-align-${title.Alignment}`);
      }

      return results;
    },
  },
  watch: {
    async reviews() {
      await this.$nextTick()
      this.flickityActivator();
    }
  },
  methods: {
    async flickityActivator() {
      this.flickityActive = false;
      if (this.centerCarousel) {
        this.flickityOptions.cellAlign = 'center'
      } else {
        this.flickityOptions.cellAlign = 'left'
      }
      // $nextTick https://vuejs.org/v2/api/#vm-nextTick
      await this.$nextTick()
      if (this.reviews.length > 2 && this.forceMobile) {
        this.flickityActive = true;
        return
      }
      if (this.reviews.length > 5) {
        this.flickityActive = true;
        return
      }
      if (window.innerWidth < 1100) {
        if (this.reviews.length > 4) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 800) {
        if (this.reviews.length > 3) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 600) {
        if (this.reviews.length > 2) {
          this.flickityActive = true;
          return
        }
      }
      if (window.innerWidth < 400) {
        if (this.reviews.length > 1) {
          this.flickityActive = true;
          return
        }
      }
      return
    },
  },
}
</script>

<style lang="scss">
  /* external css: flickity.css */
  .c-review-carousel {
    .l-grid {
      align-items: start;
    }
  }

  //flickity class override for forced mobile
  .flickity {
    &:focus-visible {
      outline: none !important;
    }
  }
  .c-review-carousel--mobile {
    .flickity-enabled.is-draggable {
      padding-left: 30px;
      padding-right: 30px;
      max-width: 550px;
      margin: auto;
    }
    .carousel-cell {
      height: auto;
      min-height: rem(290px);
      margin-right: rem(10px);
      border-radius: 5px;
      width: 50%;
      border-radius: 5px;
      counter-increment: gallery-cell;
    }



    // prev and next buttons
    .flickity-prev-next-button {
      top: 50%;
    }
    button.flickity-prev-next-button {
      width: 55px;
      height: 55px;
    }
    .flickity-prev-next-button.previous svg.flickity-button-icon {
      left: 0;
      @include themify($themes) {
        color: themed('foreground');
      }
    }
    .flickity-prev-next-button.next svg.flickity-button-icon {
      right: 0;
      @include themify($themes) {
        color: themed('foreground');
      }
    }
  }

  //flickity class override
  .c-review-carousel {
    .flickity-enabled.is-draggable {
      padding-left: 30px;
      padding-right: 30px;
      margin: auto;
    }
    .carousel-cell {
      height: auto;
      min-height: rem(290px);
      margin-right: rem(5px);
      margin-left: rem(5px);
      border-radius: 5px;
      width: 24.5%;

      @include respond(phone) {
        width: 100%;
      }

      @include respond(tab-land) {
        width: 50%;
      }
      border-radius: 5px;
      counter-increment: gallery-cell;
    }
  }
</style>
